import {
  SPI,
  BaseElementWidget,
  ViewType,
  SEARCH_WIDGET,
  SearchWidget,
  Widget,
  getRouterInstance,
  RefreshCallChainingParameters,
  RefreshCallChainingScope,
} from '@kunlun/dependencies';
import { nextTick } from 'vue';
@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Search,
    widget: ['search', SEARCH_WIDGET]
  })
)
export class ClearInputSpaces extends SearchWidget {
  @Widget.Method()
  public async onReset() {
    await super.onReset()
    if (this.model.model === 'deli.aries.promotion.DeliAriesPromotionPlanDisableProxy') {
      this.onSearch()
    }
  }

  @Widget.Method()
  @Widget.Provide()
  public onSearch() {
    const { searchString, searchBody, searchRequestCondition } = this.getSearchCondition();
    const isEqual = this.searchString === searchString;
    if (!isEqual) {
      this.searchString = searchString;
      if (!this.inline) {
        getRouterInstance()!.push({
          segments: [
            {
              path: 'page',
              parameters: searchRequestCondition,
              extra: { preserveParameter: true }
            }
          ]
        });
      }
    }
    let searchBodyCopy: {
      [x: string]: unknown;
      __draftId?: string | undefined;
      __parentDraftId?: string | undefined;
      __hasChildren?: boolean | undefined;
      __lastUpdateFromLocal?: boolean | undefined;
      __updateTimestamp?: string | undefined;
    } = {}

    Object.entries(searchBody).forEach(([key, value]) => {
      searchBodyCopy[key] = typeof value === 'string' ? value.trim() : searchBody[key]
    })
    if (this.model.model === 'deli.aries.promotion.DeliAriesPromotionPlanDisableProxy' && JSON.parse(this?.urlParameters?.context ?? '')?.planId) {
      searchBodyCopy.planId = JSON.parse(this?.urlParameters?.context ?? '')?.planId ?? ''
    }
    this.flushSearchParameters?.(searchBodyCopy, this.searchConditions);
    const refreshParameter: RefreshCallChainingParameters = {
      scope: RefreshCallChainingScope.search,
      refreshParent: false,
      currentPage: 1
    };
    this.refreshCallChaining?.syncCall(refreshParameter);
  }


  @Widget.Watch('parentViewActiveRecords')
  private async onClear(newValue, oldValue) {
    if (this.model.moduleName === "deliRetail" && this.model.model == 'deli.retail.RetailItem') {
      await super.onReset?.()
    }
  }

}

